// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"aa5c7b87","29":"b58e885b","209":"d3b27ff9","256":"72d2cc7e","453":"193db06f","467":"0bf9c163","520":"d3eff380","753":"ae6c9d51","917":"8d050c29","935":"7065ce5c"}[chunkId] + ".chunk.js";
};